export { default } from "./CollectionCardVisualization";
